import { ApiError } from '@/models/common.model';
import { Auth0User, CurrentUser } from '@/models/user.model';
import { useGetCurrentUserQuery } from '@/services/api/auth.api';
import { parseApiError } from '@/utils/api-error.util';
import { Auth0ContextInterface, useAuth0 } from '@auth0/auth0-react';

type AuthHookReturn<U> = {
  isAuthenticated: boolean;
  isLoading: boolean;
  currentUser: U;
  error: ApiError | null;
} & Omit<Auth0ContextInterface<Auth0User>, 'user' | 'error'>;

export const useAuth = <U = CurrentUser>(): AuthHookReturn<U> => {
  const auth0 = useAuth0();
  const {
    isAuthenticated,
    isLoading: isLoadingAuth0,
    user: _user,
    ...otherAuth0Values
  } = auth0;

  const {
    data: currentUser,
    error,
    isLoading
  } = useGetCurrentUserQuery(undefined, {
    skip: !isAuthenticated || isLoadingAuth0
  });

  return {
    ...otherAuth0Values,
    isAuthenticated,
    isLoading: isLoading || isLoadingAuth0,
    error: error ? parseApiError(error as any) : null,
    currentUser: currentUser as U
  };
};
